import AllItemsToggler from './AllItemsToggler/AllItemsToggler';
import Container from './Container/Container';
import SearchInput from './SearchContainer/SearchContainer'
import ItemsList from './ItemsList/ItemsList'
import Footer from './Footer/Footer'

const Filter = {
  AllItemsToggler,
  Container,
  SearchInput,
  ItemsList,
  Footer
};

export default Filter;
